"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedDocumentSide = exports.SHARED_DOCUMENTS_ROLES = exports.sharedDocumentsOpenOutsideOffice = exports.PROJECT_SHARED_DOCUMENTS_OPEN_STEPS = exports.PROJECT_SHARED_DOCUMENTS_QUIET_MINUTES = exports.PROJECT_SHARED_DOCUMENTS_MAX = void 0;
const account_type_1 = require("../accounts/account-type");
const steps_1 = require("../project/steps");
const order_1 = require("../project/order");
/**
 * #883 — The shared documents of a dossier.
 *
 * Files the architect's office, the commercial side (SALESMAN or their company,
 * SOCIETY) and the dossier's client exchange during its life, outside the permit
 * pieces: a photo taken afterwards, a quote, a marked-up plan, a letter from the
 * town hall. Stored as `project_files` rows of usage `PROJECT_SHARED_DOCUMENT`.
 *
 * They never count as a required piece, are never reviewed and never go into the
 * sent dossier. These rules are read by the backend (upload ticket and
 * notification) and by the frontend (section, counter), so the two cannot drift.
 */
/** The commercial side and the client add while the dossier holds fewer shared
 *  documents than this, whoever added them. The architect's office is not held
 *  to it. A dossier lives for months, so the room is wider than a study's (10). */
exports.PROJECT_SHARED_DOCUMENTS_MAX = 30;
/** Additions quiet for this long are mailed to the other side as one e-mail. */
exports.PROJECT_SHARED_DOCUMENTS_QUIET_MINUTES = 10;
/**
 * The steps at which the commercial side and the client may add, and remove what
 * their side added. Every step but an abandoned dossier: the space stays open
 * after the sending, the deposit and the end of the dossier, since that is when
 * a town-hall letter arrives. An abandoned dossier is frozen for them; the office
 * keeps its hands on it.
 */
exports.PROJECT_SHARED_DOCUMENTS_OPEN_STEPS = order_1.PROJECT_STEP_ORDER.filter((step) => step !== steps_1.ProjectStep.PROJECT_ABANDONED);
/** Whether the commercial side and the client may still add or remove at this step. */
const sharedDocumentsOpenOutsideOffice = (step) => step != null && exports.PROJECT_SHARED_DOCUMENTS_OPEN_STEPS.includes(step);
exports.sharedDocumentsOpenOutsideOffice = sharedDocumentsOpenOutsideOffice;
/** The roles that see a dossier's shared documents. */
exports.SHARED_DOCUMENTS_ROLES = [
    account_type_1.AccountType.ARCHITECT,
    account_type_1.AccountType.COLLABORATOR,
    account_type_1.AccountType.SALESMAN,
    account_type_1.AccountType.SOCIETY,
    account_type_1.AccountType.CLIENT,
];
const sharedDocumentSide = (addedByCommercial, addedByClient) => (addedByCommercial ? 'commercial' : addedByClient ? 'client' : 'office');
exports.sharedDocumentSide = sharedDocumentSide;
//# sourceMappingURL=shared-documents.js.map